module.exports = __webpack_public_path__ + "static/h4-3c52120da95b7f6c8e2f80a97d88657e.gif";